import { IDropDownOption, IOptionItem, ITextBoxOption } from "./pageReader"
import { ICreateAddressRequest, ISubscriptionInfo } from "./Subscription"

export interface IAuthorizedResponse {
    Value: {
        AccessToken: string
        RefreshToken: string
        ExpiresIn: number
        IsNewUser: boolean
    }
}

// Refresh Token
export interface IRefreshTokenRequestBody {
    Token: string,
    RefreshParentalControl?: boolean,
    OtpVerificationToken?: string,
    OtpUserInput?: string
}

export interface IRefreshToken {
    AccessToken: string,
    RefreshToken: string,
    ExpiresIn: number
}

export interface IRefreshTokenResponse {
    Value: IRefreshToken
}



export interface IRole {
    RoleName: string,
    Permissions: string[]
}

export interface IDeclaration {
    IsAbove18: boolean,
    IsMarketingOptedIn: boolean;
}
export interface IUserInfo {
    UserId: string | null,
    Fullname: string | null,
    Email: string | null,
    Mobile: string | null,
    Gender: string | null,
    Dob: string | null,
    Grade: string | null,
    MotherTongue: string | null,
    PreferredLanguage: string | null,
    GuardianName: string | null,
    Address: string | null,
    PrimaryAddress: ICreateAddressRequest | null,
    PictureUrl: string | null,
    PrimarySubscription: string | null,
    Declarations: IDeclaration | null,
    Roles: IRole[],
    Subscriptions: ISubscriptionInfo[]
}


export interface IGetUserRouteParameters {
    userId: string
}

export interface IGetUserQueryParameters {
    includeRoles: boolean
}

export interface IGetUserRequestInfo {
    routeParameters: IGetUserRouteParameters,
    queryParameters: IGetUserQueryParameters
}

export interface IGetUserResponse {
    Value: IUserInfo
}

// UpdateUser
export interface IUpdateUserInfo {
    Fullname?: string | null,
    Email?: string | null,
    Mobile?: string | null,
    Gender?: string | null,
    Dob?: string | null,
    Address?: string | null,
    PrimaryAddress?: ICreateAddressRequest | null,
    GuardianName?: string | null,
    MotherTongue?: string | null,
    PictureUrl?: string | null,
    Declarations?: IDeclaration,
    PreferredLanguage?: string | null
}

export interface IUpdateUserInfoResponse {
    Value: IUserInfo
}
export interface IDeleteAccountResponse {
    Value: string
}
export enum UserBookStatus {
    Unopened = "Unopened",
    Reading = "Reading",
    Completed = "Completed"
}

export enum UserBookRole {
    FullAccess = "FullAccess",
    LimitedAccess = "LimitedAccess",
    Admin = "Admin",
}

export interface IUserBooksResponse {
    PageNumber: number | null,
    PageSize: number | null,
    RecordsInPage: number | null,
    TotalPages: number | null,
    TotalCount: number | null,
    Value: IUserBook[]
}

export interface IUserBook {
    BookId: string | null,
    Title: string | null,
    Description: string | null,
    DefaultLanguage: string | null,
    ThumbnailUrl: string | null,
    AudioUrl: string | null,
    UserBookStatus: UserBookStatus,
    AccessType: UserBookRole,
    IsLocked: boolean,
    TotalChapters: number,
    CompletedChapters: number,
    TotalPages: number,
    CompletedPages: number,
    RPAllowed: boolean
}

export enum UserChapterStatus {
    Unopened = "Unopened",
    Reading = "Reading",
    Completed = "Completed"
}

export interface IChapterWithSubChapters {
    ChapterId: string | null,
    GroupName: string | null,
    Type: number,
    Title: string | null,
    Description: string | null,
    AudioFileUrl: string | null,
    ThumbnailUrl: string | null,
    UserChapterStatus: UserChapterStatus,
    SubChapters: IChapterWithSubChapters[],
    AccessDenied?: boolean
}

export interface IUserBookWithChapter extends IUserBook {
    Chapters: IChapterWithSubChapters[] | null;
    LastReadChapterId?: string;
}

export interface IUserBookWithChapterResponse {
    Value: IUserBookWithChapter
}

export interface ISection {
    SectionId: string,
    Data: string | null
}
export enum ScreenMeasuringUnit {
    cm = 1,
    inch = 2,
    pixel = 3
}
export interface IScreenSize {
    label: string;
    width: number;
    height: number;
    unit: ScreenMeasuringUnit
}
export interface ILayout {
    Cols: number,
    Rows: number,
    Data: string | null,
    Sections: ISection[]
}

export interface ITranslation {
    TranslationID: string,
    Text?: string,
    Language?: string,
    AudioUrl?: string
}

export interface IPageWithLayout {
    PageID: string,
    Type: number,
    TimeSpentInMinutes: number,
    Layout: ILayout,
    Index: number,
    IndexZ: number,
    Translation?: ITranslation,
    AudioUrl?: string,
    AccessDenied?: boolean
}

export interface PropInfo {
    nname: string
    label: string
    binding: string
    inputType: 'text' | 'number' | 'color' | 'gradientcolor' | 'dropdown' | 'file' | 'multiSelect' | 'tags' | 'none' | 'multiOptionTextBox' | 'audio' | 'decimal'
    value: any
    hidden?: boolean
    isReadOnly?: boolean
    options?: IDropDownOption[] | IOptionItem[] | ITextBoxOption[]
}

export interface IUserChapterWithPages {
    ChapterId: string | null,
    GroupName: string | null,
    Type: number,
    Title: string | null,
    Description: string | null,
    AudioFileUrl: string | null,
    ThumbnailUrl: string | null,
    UserChapterStatus: UserChapterStatus,
    PreviousPages: IPageWithLayout[],
    CurrentPage: IPageWithLayout | null,
    NextPages: IPageWithLayout[],
    TotalPages: number,
    TotalPagesZ: number
}

export interface IUserChapterWithPagesResponse {
    Value: IUserChapterWithPages
}

export interface IUserChapterWithAllPages extends IUserChapterWithPages {
    AllPages: IPageWithLayout[]
}

export interface ISendInvoiceRequest {
    OrderId: string;
}

export interface ISendInvoiceResponse {
    OrderId: string;
    EmailResponse?: string;
}

// Sessions
export interface IRemoveDevicesRequest {
    DeviceIds: string[];
    RemoveAll: boolean;
    IsWeb: boolean;
};

// Session Revoke
export interface IRevokeSessionsRequest {
    SessionIds: string[];
    RevokeAll: boolean;
};

export interface ISessionTokenRequest {
    SessionToken: string;
};

export interface ISessionResponse {
    SessionToken: string;
    ExpiresAt: string;
};

export interface ICreateSessionRequest {
    Name: string;
    Fingerprint: string;
    Type: "Mobile" | "Tablet" | "Website";
    OS: string;
};


export interface ISetting {
    Key: string;
    Value: string;
}
